import { Template, LazyTemplate } from "../../core/template/index";
import { View } from "../../core/view";
import { JobEntry } from "../../app/datatypes";
import OrderFlipcardView from "../orderFlipcard/index";
import AppHeader from "../../core/app/header";
import { ValtasiirtoBaseApp } from "../../app/valtaSiirtoBaseApp";
import Order, { OrderLike } from "../../app/db/models/order";
import * as ArrayHelpers from "../../core/helpers/array";
import TabControlView from "../../core/views/tabControl/index";
import { AutoSyncEndEvent, AutoSyncResult } from "../../core/synchronizer/index";

export default class OrderListView extends View
{
    public app: ValtasiirtoBaseApp;
    public template = Template.lazy('/views/orderList/index.html');   
    public availableOrdersContainer: HTMLElement;
    public runningOrdersContainer: HTMLElement;

    private orders: OrderLike[];
    private orderViews: OrderFlipcardView[];

    private tabControl: TabControlView;

    public data: OrderListViewData;
    
    constructor(data)
    {
        super(data);
        this.orderViews = [];
    }

    private resolveActiveTabPage()
    {
        if (this.data.activeTabPage != null)
            return this.data.activeTabPage;
        else if (this.data.assignedOrderCount > 0)
            return Order.STATE_ASSIGNED;
        else if(this.data.availableOrderCount > 0)
            return Order.STATE_AVAILABLE;
        else
            return Order.STATE_AVAILABLE;
    }

    public beforeRender(): PromiseLike<void>
    {
        this.app.header.text = this.pgettext('Title - list of orders', 'Orders');
        this.orderViews = [];

        return Order.withAll(this.app.db, this.app.db.Order.where('state').equals(Order.STATE_AVAILABLE).or('state').equals(Order.STATE_ASSIGNED))
        .then((orders) =>
        {   
            this.orders = orders;

            this.data.availableOrderCount = ArrayHelpers.sum(this.orders, order => order.state == Order.STATE_AVAILABLE ? 1 : 0);
            this.data.assignedOrderCount = ArrayHelpers.sum(this.orders, order => order.state == Order.STATE_ASSIGNED ? 1 : 0);

            const viewRenders: PromiseLike<any>[] = [];
            
            Order.sort(this.orders); 

            for(const order of this.orders) {
                (order as any).priorityCssClassName = Order.priorityCssClassName(order);
                (order as any).priorityLabel = Order.priorityLabel(this, order);

                let view = new OrderFlipcardView(order);
                viewRenders.push(this.app.renderPartialView(view));
                this.orderViews.push(view);
            }

            console.table(this.orders);
            
            this.tabControl = new TabControlView({
                activePage: this.resolveActiveTabPage(),
                tabPageClassNames: 'item-container orders',
                pages: [
                    {title: this.pgettext('Title - available orders', 'Available'), id: Order.STATE_AVAILABLE, itemCount: this.data.availableOrderCount},
                    {title: this.pgettext('Title - assigned orders', 'Assigned'), id: Order.STATE_ASSIGNED, itemCount: this.data.assignedOrderCount},
                ]
            });
            viewRenders.push(this.app.renderPartialView(this.tabControl));
            return Promise.all(viewRenders);
        }).then(() =>
        {

        });
    }
    
    public afterRender(): PromiseLike<void>
    {
        for(let view of this.orderViews)
        {
            this.tabControl.getPage(view.data.state).appendChild(view.element);
        }  

        this.appendChild(this.tabControl);

        this.app.synchronizer.on('autoSyncEnd', this.onAutoSyncEnd);

        return super.afterRender();
    }

    private onAutoSyncEnd = (e: AutoSyncEndEvent) =>
    {
        this.data.activeTabPage = this.tabControl.activePage;
        if (e.result === AutoSyncResult.CHANGED)
        {
            this.app.refreshCurrentView();
        }
    }

    public unload(): PromiseLike<void>
    {
        this.app.synchronizer.off('autoSyncEnd', this.onAutoSyncEnd);
        return super.unload();
    }
}

export interface OrderListViewData
{
    assignedOrderCount: number;
    availableOrderCount: number;
    activeTabPage?: string;
}